import { render, staticRenderFns } from "./MyParent.vue?vue&type=template&id=1145f0a8&scoped=true"
import script from "./MyParent.vue?vue&type=script&lang=js"
export * from "./MyParent.vue?vue&type=script&lang=js"
import style0 from "./MyParent.vue?vue&type=style&index=0&id=1145f0a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1145f0a8",
  null
  
)

export default component.exports